import React, {Component} from 'react';
import{Modal} from 'react-bootstrap';
import '../CSS/stockData.css';
import StockList from '../Components/StockList';

//Displays the stock Modal
export class StockDataModal extends Component{
  constructor(props){
    super(props);
    }
  render()
  {
    return(
      <Modal
      {...this.props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered className="ModalStock"
    >
    <Modal.Header className ="ModalHeaderStock"></Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter" className = "ModalTitleStock">
          Live Stock Data
      </Modal.Title>
      <Modal.Body className = "ModalBodyStock">
      {/* Please allow some time as the stock data loading takes some time*/}
      <p> (Please wait until the stock loads)</p>
      <div className = "col-md-5 mt-5">
      <div className = "card">
      <StockList/>
      </div>
      </div>
      <button  className = "ButtonCloseStock" onClick={this.props.onHide}>Close</button>
      </Modal.Body>
    </Modal>
    );
  }
}